import { Link } from 'library';
import React from 'react';

export default function MoreDetailsCell({ text, toggleExpanded }: { text: string; toggleExpanded: () => void }) {
    return <Link onClick={toggleExpanded}>{text}</Link>;
}
